import Axios from "axios";
import {
  SET_SALES_ACCOUNTS_RECEIVABLE_AGING_REPORT_LIST,
  UNSET_SALES_ACCOUNTS_RECEIVABLE_AGING_REPORT_LIST,
} from "@/store/mutation-types";
import {
  getSalesAcountsReceivableAging,
} from "@/store/api";

const state = { 
  getSalesAcountsReceivableAging: [],
};

const getters = {
  getSalesAcountsReceivableAging(state) {
    return state.getSalesAcountsReceivableAging;
  },
};

const mutations = {
  [SET_SALES_ACCOUNTS_RECEIVABLE_AGING_REPORT_LIST](state, data) {
    state.getSalesAcountsReceivableAging = data;
  },
  [UNSET_SALES_ACCOUNTS_RECEIVABLE_AGING_REPORT_LIST](state) {
    state.getSalesAcountsReceivableAging = [];
  },
};

const actions = {
  getSalesAcountsReceivableAging({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getSalesAcountsReceivableAging}`, { params: data})
        .then((response) => {
          commit(SET_SALES_ACCOUNTS_RECEIVABLE_AGING_REPORT_LIST, response.data.data);
          resolve(response.data.data);
        })
        .catch((error) => {
          commit(UNSET_SALES_ACCOUNTS_RECEIVABLE_AGING_REPORT_LIST);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },
};  

export default {
  state,  
  getters,
  actions,
  mutations,
};

